import React from 'react';
//import PropTypes from 'prop-types';


const buildResult = (prevResult, state, value) => {
  const result = {
    state,
    
    isPending: state === 'pending',
    isUpdating: state === 'updating',
    isResolve: state === 'resolve',
    isRejected: state === 'rejected'
  };
  
  result.isLoading = result.isPending || result.isUpdating;
  result.isComplete = result.isResolve || result.isRejected;
  result.data = prevResult?.data;
  result.error = prevResult?.error;
  
  if (result.isResolve) {
    result.data = value;
    result.error = undefined;
  } else if (result.isRejected) {
    result.error = value;
  }
  
  return result;
};


const STATE_PENDING_DEFAULT = buildResult(undefined, 'pending');


export default (promise, dependencies) => {
  const version = React.useRef(0);
  const complete = React.useRef(false);
  
  const [state, setState] = React.useState(STATE_PENDING_DEFAULT);
  
  
  React.useEffect(() => {
    if (!promise)
      return;
    
    const ver = ++version.current;
    
    setState(buildResult(state, complete.current ? 'updating' : 'pending'));
    
    promise(...dependencies)
      .then((data) => ver === version.current && setState(buildResult(state, 'resolve', data)))
      .catch((error) => ver === version.current && setState(buildResult(state, 'rejected', error)))
      .finally(() => ver === version.current && (complete.current = true));
    
    return () => version.current++;
  }, [!promise, ...dependencies]);
  
  
  return state;
};
